var EnablePrivilage = true;
const ENABLE_PAYMENT_CHANGES: boolean = false;

// Production
export const ENDPOINT: string = "https://khedma.app:8081";
// Test
// export const ENDPOINT: string = "https://khedma.app:8085";

import { Injectable } from '@angular/core';

@Injectable()
export class ConfigClass {

  public static get getPrivilageStatus() {
    return EnablePrivilage;
  }

  public static set setPrivilageStatus(val) {
    EnablePrivilage = val;
  }

  static get getEndpoint() {
    return ENDPOINT;
  }

  static get getPaymentStatus() {
    return ENABLE_PAYMENT_CHANGES;
  }

}

export enum EditPrivilege {
  SUBSCRIPTION_EDIT = "SUBSCRIPTION_EDIT",
  SUBSCRIPTION_CATEGORY_EDIT = "SUBSCRIPTION_CATEGORY_EDIT",
  GATE_ACCESS_EDIT = "GATE_ACCESS_EDIT",
  ACCESS_CARD_EDIT = "ACCESS_CARD_EDIT",
  PROJECTS_EDIT = "PROJECTS_EDIT",
  PROPERTY_EDIT = "PROPERTY_EDIT",
  ORDERS_EDIT = "ORDERS_EDIT",
  CUSTOMIZED_ORDERS_EDIT = "CUSTOMIZED_ORDERS_EDIT",
  USERS_EDIT = "USERS_EDIT",
  SERVICE_EDIT = "SERVICE_EDIT",
  OFFERS_EDIT = "OFFERS_EDIT",
  CS_ORDERS_EDIT = "CS_ORDERS_EDIT",
  CS_CUSTOMIZED_ORDERS_EDIT = "CS_CUSTOMIZED_ORDERS_EDIT",
  NOTIFICATIONS_SEND = "NOTIFICATIONS_SEND",
  CS_COMPLAIN_EDIT = 'CS_COMPLAIN_EDIT',
  COMPLAIN_AGRICULTURE_EDIT = 'COMPLAIN_AGRICULTURE_EDIT',
  COMPLAIN_ENGINEERING_EDIT = 'COMPLAIN_ENGINEERING_EDIT',
  COMPLAIN_ENVIRONMENT_EDIT = 'COMPLAIN_ENVIRONMENT_EDIT',
  COMPLAIN_FINANCIAL_EDIT = 'COMPLAIN_FINANCIAL_EDIT',
  COMPLAIN_MAINTENANCE_EDIT = 'COMPLAIN_MAINTENANCE_EDIT',
  COMPLAIN_SECURITY_EDIT = 'COMPLAIN_SECURITY_EDIT',
  COMPLAIN_TRANSPORTATION_EDIT = 'COMPLAIN_TRANSPORTATION_EDIT',
  COMPLAIN_OTHER_EDIT = 'COMPLAIN_OTHER_EDIT',
  TIMELINES_EDIT = 'TIMELINES_EDIT',
  SOS = 'SOS'
}

export enum ViewPrivilege {
  SUBSCRIPTION = "SUBSCRIPTION",
  SUBSCRIPTION_CATEGORY = "SUBSCRIPTION_CATEGORY",
  GATE_ACCESS = "GATE_ACCESS",
  ACCESS_CARD = "ACCESS_CARD",
  PROJECTS = "PROJECTS",
  PROPERTY = "PROPERTY",
  ORDERS = "ORDERS",
  CUSTOMIZED_ORDERS = "CUSTOMIZED_ORDERS",
  USERS = "USERS",
  SERVICE = "SERVICE",
  OFFERS = "OFFERS",
  DASHBOARD = "DASHBOARD",
  CS_ORDERS = "CS_ORDERS",
  CS_CUSTOMIZED_ORDERS = "CS_CUSTOMIZED_ORDERS",
  NOTIFICATIONS = "NOTIFICATIONS",
  CS_COMPLAIN = 'CS_COMPLAIN',
  COMPLAIN_AGRICULTURE = 'COMPLAIN_AGRICULTURE',
  COMPLAIN_ENGINEERING = 'COMPLAIN_ENGINEERING',
  COMPLAIN_ENVIRONMENT = 'COMPLAIN_ENVIRONMENT',
  COMPLAIN_FINANCIAL = 'COMPLAIN_FINANCIAL',
  COMPLAIN_MAINTENANCE = 'COMPLAIN_MAINTENANCE',
  COMPLAIN_SECURITY = 'COMPLAIN_SECURITY',
  COMPLAIN_TRANSPORTATION = 'COMPLAIN_TRANSPORTATION',
  COMPLAIN_OTHER = 'COMPLAIN_OTHER',
  TIMELINES = 'TIMELINES',
  SOS = 'SOS'
}
